import { Component } from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';
import { RouterOutlet, Router, Event, NavigationEnd } from '@angular/router';
import { ConfirmationModalComponent } from './core/confirmation-modal/confirmation-modal.component';
import { ModalService } from './services/modal.service';
import { LoadingService } from './services/loading.service';
import { LoaderComponent } from './core/loader/loader.component';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule, ConfirmationModalComponent, LoaderComponent], //SidebarSettingsComponent
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {

    title = 'Trezo - Angular 19 Bootstrap Admin Dashboard Template';

    constructor(
        private router: Router,
        private viewportScroller: ViewportScroller,
        public modalService: ModalService,
        public loadingService: LoadingService,
        private toastr: ToastrService
    ) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                // Scroll to the top after each navigation end
                this.viewportScroller.scrollToPosition([0, 0]);
            }
        });
    }

}